var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCalendar(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.2956 2C7.80133 2 8.21131 2.40049 8.21131 2.89453V3.32121H11.7883V2.89453C11.7883 2.40049 12.1983 2 12.704 2C13.2097 2 13.6197 2.40049 13.6197 2.89453V3.32121H14.7413C15.9887 3.32121 17 4.30909 17 5.52771V14.7935C17 16.0121 15.9887 17 14.7413 17H5.25874C4.01127 17 3 16.0121 3 14.7935V5.5277C3 4.30909 4.01127 3.32121 5.25874 3.32121H6.37989V2.89453C6.37989 2.40049 6.78987 2 7.2956 2ZM6.37989 5.11026H5.25874C5.02273 5.11026 4.83141 5.29716 4.83141 5.5277V7.28424H15.1686V5.52771C15.1686 5.29716 14.9773 5.11026 14.7413 5.11026H13.6197V5.53669C13.6197 6.03072 13.2097 6.43122 12.704 6.43122C12.1983 6.43122 11.7883 6.03072 11.7883 5.53669V5.11026H8.21131V5.53669C8.21131 6.03072 7.80133 6.43122 7.2956 6.43122C6.78987 6.43122 6.37989 6.03072 6.37989 5.53669V5.11026ZM15.1686 9.07329H4.83141V14.7935C4.83141 15.0241 5.02273 15.2109 5.25874 15.2109H14.7413C14.9773 15.2109 15.1686 15.0241 15.1686 14.7935V9.07329Z",
    fill: "#22292F"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendar);
export default __webpack_public_path__ + "static/media/calendar.98771756c8dd643322f42db535cc470b.svg";
export { ForwardRef as ReactComponent };